import React from 'react'
import { Tooltip } from 'antd';
import "./IconTag.scss"
// function IconTag({ Icon, title, color }) {
//     return (
//         <div className='icon-tag' style={color ? { color: color } : {}}> {Icon && <Icon twoToneColor={color} />}<span>{title}</span></div>
//     )
// }

function IconTag({ Icon, title, color, tooltipText }) {
    return (
      <Tooltip title={tooltipText}>
        <div className='icon-tag' style={color ? { color: color } : {}}>
          {Icon && <Icon twoToneColor={color} />}
          <p>{title}</p>
        </div>
      </Tooltip>
    );
  }

export default IconTag